const dateNowUs = () => {
  const date = new Date()

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date.toLocaleDateString('fr-CA', options)
}

const dateNowUs30ago = () => {
  const today = new Date()
  const date = new Date(new Date().setDate(today.getDate() - 30))

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date.toLocaleDateString('fr-CA', options)
}

const dateNowUsOneYearAgo = () => {
  const today = new Date()
  const date = new Date(new Date().setDate(today.getDate() - 365))

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date.toLocaleDateString('fr-CA', options)
}

const dateTimeSqlToDateTimeBR = (value) => {
  const date = new Date(value)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }
  return date.toLocaleDateString('pt-BR', options)
}

const dateTimeSqlToDateBR = (value) => {
  const date = new Date(`${value} 00:00:00`)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date.toLocaleDateString('pt-BR', options)
}

const dateTimeRmToDateBR = (value) => {
  const date = new Date(`${value}`)
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  const dateFinal = date.toLocaleDateString('pt-BR', options)
  return dateFinal === 'Invalid Date' ? '' : dateFinal
}

const compare2Dates = (date1, date2) => {
  const d1 = new Date(date1)
  d1.setHours(0, 0, 0, 0)

  const d2 = new Date(`${date2} 00:00:00`)

  return d1.getTime() - d2.getTime() > 0
    ? '<span class="badge bg-danger">Vencido</span>'
    : '-'
}

const contractExpirationDate = (expireAt) => {
  const now = new Date()
  const dateWithOutT = expireAt.replace('T', ' ')
  const expireAtDate = new Date(dateWithOutT)

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  const formatedDate = expireAtDate.toLocaleDateString('pt-BR', options)

  if (now < expireAtDate) {
    return `<span class="badge bg-warning text-dark">${formatedDate}</span>`
  }
  if (now > expireAtDate) {
    return `<span class="badge bg-danger">${formatedDate}</span>`
  }
  return '<span class="badge bg-info">Não Identificado</span>'
}

export {
  dateNowUs,
  dateNowUs30ago,
  dateNowUsOneYearAgo,
  dateTimeSqlToDateTimeBR,
  dateTimeSqlToDateBR,
  dateTimeRmToDateBR,
  compare2Dates,
  contractExpirationDate,
}
